import {
    Component,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { IOption } from '@cmps/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { Store } from 'redux';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    CmpsForm,
    CmpsFormBuilder,
    CmpsFormField,
    CmpsFormFields,
} from '../common/experimental.form';
import { STORE } from '../store.metadata';

import { TranslationKeyMap } from './tdcf-form.i18n';
import { HierarchyInfo } from './tdcf.model';

interface FormFieldsKey extends CmpsFormFields {
    QUERY: CmpsFormField;
}

const FormFields: FormFieldsKey = {
    QUERY: {
        id: `query${Math.random()}`,
        name: 'query',
        labelId: `query${Math.random()}`,
        label: TranslationKeyMap._7212_STEP_HIERARCHY,
        placeholder: TranslationKeyMap._7212_STEP_HIERARCHY,
    },
};

@Component({
    selector: '[cmpsTdcfSearch]',
    templateUrl: './search.tdcf.component.html',
    host: {
        class: 'cmps-tdcf-search',
    },
})
export class SearchTdcfComponent implements OnChanges, OnInit, OnDestroy {
    @Input() currentUserId: number;
    @Input() info: HierarchyInfo;

    i18n = TranslationKeyMap;
    form: CmpsForm<FormFieldsKey>;
    private _formSub: Subscription;
    selectedUserLabel: string;
    userOpts: IOption[];

    constructor(
        private readonly _router: Router,
        private readonly _translateService: TranslateService,
        @Inject(STORE) private readonly _store: Store,
        private readonly _formBuilder: CmpsFormBuilder,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('info')) {
            this.selectedUserLabel = `${this.info.firstName} ${this.info.lastName} | ${this.info.roleName}`;
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            const manager = this.info.manager &&
                this.info.manager.firstName && {
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    label: `(${this._translateService.instant(
                        TranslationKeyMap._48_MANAGER,
                    )}) ${this.info.manager.lastName}, ${
                        this.info.manager.firstName
                    } | ${this.info.manager.roleName}`,
                    value: this.info.manager,
                };
            const direct = this.info.team
                .filter((m) => m.manager.userId === this.info.userId)
                .map((m) => ({
                    label: `${m.lastName}, ${m.firstName} | ${m.roleName}`,
                    value: m,
                }));
            const team = this.info.team
                .filter((m) => m.manager.userId !== this.info.userId)
                .map((m) => ({
                    label: `${m.manager.lastName}, ${m.manager.firstName} > ${m.lastName}, ${m.firstName} | ${m.roleName}`,
                    value: m,
                }))
                .sort((a, b) => a.label.localeCompare(b.label));
            this.userOpts = !manager
                ? direct.concat(team)
                : [manager].concat(direct, team);
        }
    }

    ngOnInit(): void {
        this.form = this._formBuilder.create(FormFields);

        this._formSub = this.form.form.controls[
            this.form.fields.QUERY.name
        ].valueChanges
            .pipe(
                tap((value) => {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this._router.navigate([], {
                        queryParams: { user: value.userId },
                        queryParamsHandling: 'merge',
                    });
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        if (this._formSub) {
            this._formSub.unsubscribe();
        }
    }
}
